import React from "react";
import { Icon } from "semantic-ui-react";
import OverlayLoader from "../../../../../OverlayLoader";
import "./index.css";

const RatingStars = ({ post, ratePost }) => {
  return (
    <div className="ratingstars">
      <span className="message">Please rate this case</span>
      <div className="stars">
        {post.isRatingPending && <OverlayLoader size="small" />}
        {[1, 2, 3, 4, 5].map(rating => (
          <Icon
            className="ratingstar"
            name={`star${rating > post.userRating ? " empty" : ""}`}
            size="large"
            key={rating}
            onClick={() => ratePost({ postId: post._id, rating })}
            color={rating > post.userRating ? null : "blue"}
          />
        ))}
      </div>
    </div>
  );
};

export default RatingStars;



// WEBPACK FOOTER //
// ./src/components/Post/Components/RatingBar/components/RatingStars/index.js